import { push } from 'connected-react-router';
import React from 'react';
import { useDispatch } from 'react-redux';
import { EmptyMessage } from '../../capturecollab/components/Empty/EmptyMessage';
import { IconLock, IconLost } from '../../capturecollab/Icons';
import { StyledLockIcon } from '../../capturecollab/modules/Permission/NoPermissions';
import { SmartContainer, Stack } from '../../styles/Containers';
import { StyledButton } from '../../styles/matieralui/Button';
import { StyledB, StyledH1, StyledP } from '../../styles/StyledHTML'
// TCC Components
export const NotFound = () => {
    const dispatch = useDispatch();
    const goTo = (path) => dispatch(push(path))
    return (
        <SmartContainer flex width="100%">
            <EmptyMessage title="Nothing here to see." icon={<IconLost color="white" />}>
                <StyledP>This <StyledB italics>page</StyledB> hasn't been found.</StyledP>
                <br />
                <StyledButton variant='contained' color='blue' onClick={() => goTo('/')}>Back To Home</StyledButton>
            </EmptyMessage>
        </SmartContainer>
    );
}